// extracted by mini-css-extract-plugin
export var dataCell = "_gs-2";
export var dataRow = "_gs-0";
export var headerRow = "_gs-1";